// Nível de atividade. Os `value` são os de sempre (o backend mapeia
// muito baixo/baixo/medio/alto para o fator de atividade); o que mudou é que
// a descrição virou a sub-linha da direita, no formato do desenho, em vez de
// um parágrafo debaixo de cada rádio.

import React, { useEffect, useState } from "react";

import { Opcoes } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "muito baixo", label: "Sedentário", sub: "quase sempre sentado" },
  { value: "baixo", label: "Leve", sub: "caminhadas, esforço leve" },
  { value: "medio", label: "Moderado", sub: "treino 3–4x na semana" },
  { value: "alto", label: "Intenso", sub: "treino pesado ou esporte" },
];

const StepActivityLevel = ({ setCanProceed, setStepData }) => {
  const [nivel, setNivel] = useState("");

  useEffect(() => {
    const valido = Boolean(nivel);
    setCanProceed(valido);
    setStepData(valido ? { ACTIVITY_LEVEL: nivel } : null);
  }, [nivel, setCanProceed, setStepData]);

  return <Opcoes opcoes={OPCOES} valor={nivel} onSelecionar={setNivel} nome="Nível de atividade" />;
};

export default StepActivityLevel;
